const contentData = [
  {
    title: "Deals near you",
    link: "/deals",
    description:
      "Set your location or preferences so you see relevant local offers"
  },
  {
    title: "Shop Securely",
    link: "/deals",
    description:
      "Browse and book with local businesses without sharing unnecessary data"
  },
  {
    title: "Tailored for you",
    link: "/deals",
    description:
      "See deals and services matched to your area and preferences"
  }
];

export default contentData;
